import {Component, Input} from '@angular/core';
import Required from '@util/decorators/required';
import {MyVotesResource} from '@services/resource/my-votes-resource';
import {Handelspartner, votesToHandelspartners} from '@app/data/handelspartner-data';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-votes-panel',
  templateUrl: './votes-panel.component.html',
  styleUrls: ['./votes-panel.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class VotesPanelComponent {
  @Required @Input() votes: MyVotesResource | 'noApplication';

  get handelspartners(): Handelspartner[] {
    /* when there's no application,we still show an empty grid */
    if (this.votes === 'noApplication') {
      return votesToHandelspartners(new MyVotesResource(0, []));
    }
    return votesToHandelspartners(this.votes);
  }
}
